@if (content) {
  @if (content.text) {
    <h2 class="_title">{{ content?.text }}</h2>
  }
  @if (!content.text) {
    <h2 i18n class="_title">Pagina niet gevonden.</h2>
  }
}
@if (!content) {
  <h2 i18n class="_title">Bad vibes! We zijn even offline.</h2>
}
